var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechRelatedTopics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.395,
    height: 37.395,
    viewBox: "0 0 37.395 37.395",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tech_Related_Topics",
    "data-name": "Tech Related Topics",
    transform: "translate(-1617.5 -3185)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 23.492,
    height: 23.492,
    transform: "translate(1624.451 3191.951)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_37",
    "data-name": "Line 37",
    y2: 2.819,
    transform: "translate(1627.897 3186)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_38",
    "data-name": "Line 38",
    y2: 2.819,
    transform: "translate(1632.595 3186)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_39",
    "data-name": "Line 39",
    y2: 2.819,
    transform: "translate(1636.981 3186)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_40",
    "data-name": "Line 40",
    y2: 2.819,
    transform: "translate(1641.366 3186)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_41",
    "data-name": "Line 41",
    y2: 2.819,
    transform: "translate(1646.064 3186)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_42",
    "data-name": "Line 42",
    y2: 2.819,
    transform: "translate(1627.897 3218.576)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_43",
    "data-name": "Line 43",
    y2: 2.819,
    transform: "translate(1632.595 3218.576)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_44",
    "data-name": "Line 44",
    y2: 2.819,
    transform: "translate(1636.981 3218.576)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_45",
    "data-name": "Line 45",
    y2: 2.819,
    transform: "translate(1641.366 3218.576)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_46",
    "data-name": "Line 46",
    y2: 2.819,
    transform: "translate(1646.064 3218.576)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_47",
    "data-name": "Line 47",
    x2: 2.819,
    transform: "translate(1618.5 3213.564)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_48",
    "data-name": "Line 48",
    x2: 2.819,
    transform: "translate(1618.5 3208.866)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_49",
    "data-name": "Line 49",
    x2: 2.819,
    transform: "translate(1618.5 3204.48)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_50",
    "data-name": "Line 50",
    x2: 2.819,
    transform: "translate(1618.5 3200.095)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_51",
    "data-name": "Line 51",
    x2: 2.819,
    transform: "translate(1618.5 3195.397)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_52",
    "data-name": "Line 52",
    x2: 2.819,
    transform: "translate(1651.076 3213.564)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_53",
    "data-name": "Line 53",
    x2: 2.819,
    transform: "translate(1651.076 3208.866)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_54",
    "data-name": "Line 54",
    x2: 2.819,
    transform: "translate(1651.076 3204.48)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_55",
    "data-name": "Line 55",
    x2: 2.819,
    transform: "translate(1651.076 3200.095)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_56",
    "data-name": "Line 56",
    x2: 2.819,
    transform: "translate(1651.076 3195.397)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 14.095,
    height: 14.095,
    transform: "translate(1629.15 3196.65)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechRelatedTopics);
export default __webpack_public_path__ + "static/media/Tech Related Topics.bcd423cfaac798ca97b24194bc035fa7.svg";
export { ForwardRef as ReactComponent };